// extracted by mini-css-extract-plugin
module.exports = {"card":"EditReviewPage_card__2q_r8"};